import AuAccordion from "./AuAccordion.vue";
import AuAvatar from "./AuAvatar.vue";
import AuBreadcrumb from "./AuBreadcrumb.vue";
import AuButton from "./AuButton.vue";
import AuCheckbox from "./AuCheckbox.vue";
import AuCountdown from "@/components/extended/AuCountdown.vue";
import AuDecimalIcon from "./AuDecimalIcon.vue";
import AuDecimalInput from "./AuDecimalInput.vue";
import AuDecimalStatic from "./AuDecimalStatic.vue";
import AuDialogModal from "./AuDialogModal.vue";
import AuDropdown from "./AuDropdown.vue";
import AuError from "./AuError.vue";
import AuEthAddress from "./AuEthAddress.vue";
import AuEthHash from "./AuEthHash.vue";
import AuIcon from "./AuIcon.vue";
import AuInput from "./AuInput.vue";
import AuList from "./AuList.vue";
import AuMarkdown from "./AuMarkdown.vue";
import AuMarkdownView from "./AuMarkdownView.vue";
import AuModal from "@/components/extended/AuModal.vue";
import AuNoData from "@/components/extended/AuNoData.vue";
import AuPagination from "@/components/extended/AuPagination.vue";
import AuSelect from "./AuSelect.vue";
import AuSkeleton from "./AuSkeleton.vue";
import AuSwitch from "./AuSwitch.vue";
import AuSwitchButton from "./AuSwitchButton.vue";
import AuTable from "./AuTable.vue";
import AuTooltip from "./AuTooltip.vue";
import AuUpload from "./AuUpload.vue";
import AuWysiwyg from "./AuWysiwyg.vue";
import Form from "./Form.vue";
const Components = {
    AuButton,
    AuAvatar,
    AuSwitchButton,
    AuIcon,
    AuBreadcrumb,
    AuTable,
    AuDialogModal,
    AuDropdown,
    AuAccordion,
    AuCheckbox,
    AuInput,
    AuSwitch,
    AuSelect,
    AuDecimalStatic,
    AuEthAddress,
    AuEthHash,
    AuDecimalInput,
    AuModal,
    AuNoData,
    AuPagination,
    AuUpload,
    AuWysiwyg,
    AuMarkdown,
    AuMarkdownView,
    AuSkeleton,
    AuTooltip,
    AuCountdown,
    AuError,
    AuDecimalIcon,
    AuList,
    Form
};
export default Components;
